import { ProductType } from "elephant-web/gql";
import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_VTM_COLLECTION_NAME = "vtm";

export const useRxCollectionVtm = (): RxCollection<Vtm> | null =>
  useRxCollection<Vtm>(RXDB_VTM_COLLECTION_NAME);

type UseRxData = Parameters<typeof useRxData<Vtm>>;
export type VtmQueryConstructor = UseRxData["1"];

const VTM_SCHEMA_LITERAL = {
  title: "vtm schema",
  version: 2,
  description: "Represents a Vtm",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    meta: SYNCABLE_META,
    productType: {
      type: "string",
      enum: Object.values(ProductType),
    },
    title: {
      type: "string",
    },
    keywords: {
      type: "array",
      items: {
        type: "string",
      },
    },
    snomedId: {
      type: ["string", "null"],
    },
  },
  required: ["id", "meta", "title", "keywords", "snomedId", "productType"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(VTM_SCHEMA_LITERAL);

export type Vtm = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const VTM_SCHEMA: RxJsonSchema<Vtm> = VTM_SCHEMA_LITERAL;
